exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-info .badge {\n  margin: 0px 0px 0px 5px;\n}\n.tab-info .iri {\n  word-wrap: break-word;\n  font-size: 75%;\n}\n", ""]);

// exports
